import { isObject } from 'lodash';

export const getFormValue = (value) => {
  if (isObject(value)) {
    return encodeURIComponent(JSON.stringify(value));
  }
  return value;
};
